export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Suit Diagnostics).2908fc46.jpg";